
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { AppConfig } from './../../../app.config';

@Injectable()
export class DeclarationsListService {
    private urlListDelcarations: string = '';
    public declarationStates: any = {
        11: 'Annulé',
        10: 'Abandonné',
        9: 'Invalidé', //  par CL
        8: 'Invalidé', //  par Citeo
        7: 'Invalidé', //  par BE
        6: 'En Attente Infos CL',
        5: 'Contrôle conforme', //  par Citeo
        4: 'Validé', //  par BE
        3: 'En cours de contrôle',
        2: 'Déclaré',
        1: 'En Cours',
        0: 'En Attente'
    };

    status: any[] = [
        { id: 11, value: 'Annulé', key: 'Annulation', ignore: true },
        { id: 10, value: 'Abandonné', key: 'Abandon', ignore: true },
        { id: [7, 8, 9], value: 'Invalidé', key: 'InvalidationCL' },
        { id: 6, value: 'En Attente Infos CL', key: 'EnAttenteInfoCL', ignore: true },
        { id: 5, value: 'Contrôle conforme', key: 'ValidationCiteo' },
       // { id: 4, value: 'Validé', key: 'ValidationBE' },
        { id: 3, value: 'En cours de contrôle', key: 'EnCoursControle' },
        { id: 2, value: 'Déclaré', key: 'ValidationCL' },
        { id: 1, value: 'En Cours', key: 'EnCours' },
        { id: 0, value: 'En Attente', key: 'EnAttente ' }
    ];


    constructor(private http: HttpClient, private _appConfig: AppConfig) {
        this.urlListDelcarations = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetDeclarations';
    }

    getListDelcarations(year): Observable<any> {
        return this.http.get(this.urlListDelcarations + '?annee=' + year)
            .catch(this.handleError);
    }

    filterDeclarations(allYears, year, state) {
        let postUrl: string = '';
        let statusString = (Array.isArray(state)) ? state.join('&etats=') : state;
        statusString = (statusString === 0) ? '0' : statusString;

        if (allYears && statusString) {
            postUrl = '?etats=' + statusString;
        } else if (allYears && !statusString) {
            postUrl = '';
        } else if (!allYears && statusString) {
            postUrl = '?annee=' + year + '&etats=' + statusString;
        } else if (!allYears && !statusString) {
            postUrl = '?annee=' + year;
        }

        return this.http.get(this.urlListDelcarations + postUrl)
            .catch(this.handleError);
    }

    private handleError(err: HttpErrorResponse) {
        let errMsg: string;
        if (err && (err.error instanceof Error)) {
            errMsg = `${err.status} - ${err.statusText || ''} ${err}`;
        } else if (err && err.error) {
            errMsg = (err.error.message ? err.error.message : err.error.toString());
        } else if (typeof err == 'string') {
            errMsg = err;
        }

        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/in/mes-declarations/services/declarations-list.service.ts